import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

export default ReleaseSchedulePage;

function ReleaseSchedule() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header title="Release Schedule" className="py-2 sm:hidden" />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto hidden max-w-2xl pb-24 pt-20 text-center sm:block">
            <h1 className="text-3xl font-bold tracking-tight text-zinc-900 sm:text-4xl dark:text-zinc-200">
              {title}
            </h1>
            <p className="mt-4 text-base leading-7 text-zinc-600 dark:text-zinc-400">
              Last updated on November 16, 2024
            </p>
          </div>
        </div>

        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc mx-auto max-w-prose dark:prose-invert prose-a:font-semibold prose-a:text-emerald-500 hover:prose-a:text-emerald-600">
            <p>Release windows are market dependent and release times may vary.</p>
            <div className="space-y-16 mt-8">
              <div>
                <h4 className="border-b border-zinc-900/5 font-normal uppercase text-zinc-500 dark:border-white/5">
                  College basketball
                </h4>
                <div className="space-y-2">
                  <div className="mt-8 font-bold text-lg">Monday-Friday</div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Early sides</span>
                    </dt>
                    <dd className="p-0">Appx. 6:20 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Early totals</span>
                    </dt>
                    <dd className="p-0">Appx. 8-8:15 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Scheduled window (sides & totals)</span>
                    </dt>
                    <dd className="p-0">10 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Unplanned releases</span>
                    </dt>
                    <dd className="p-0">Possible with 5-10 minute warning</dd>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="mt-8 font-bold text-lg">Saturday-Sunday</div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Early sides</span>
                    </dt>
                    <dd className="p-0">Appx. 6:20 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Scheduled window (sides & totals)</span>
                    </dt>
                    <dd className="p-0">8-8:15 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Unplanned releases</span>
                    </dt>
                    <dd className="p-0">Possible with 5-10 minute warning</dd>
                  </div>
                </div>
              </div>
              <div>
                <h4 className="border-b border-zinc-900/5 font-normal uppercase text-zinc-500 dark:border-white/5">
                  NFL
                </h4>
                <div className="space-y-2">
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Monday & Tuesday</span>
                    </dt>
                    <dd className="p-0">Sides & totals: Appx. 7:30-9:30 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Wednesday-Saturday</span>
                    </dt>
                    <dd className="p-0">Unplanned releases possible with 5-10 minute warning</dd>
                  </div>
                  {/* <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Sunday</span>
                    </dt>
                    <dd className="p-0">
                      <a
                        href="https://www.youtube.com/@raspicks/streams"
                        target="_blank"
                        rel="noreferrer"
                      >
                        NFL Release Show
                      </a>
                      : 8 a.m. PT
                    </dd>
                  </div> */}
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Gameday</span>
                    </dt>
                    <dd className="p-0">8:30 a.m. PT</dd>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function ReleaseSchedulePage() {
  return <ReleaseSchedule />;
}
